'use strict';exports.__esModule = true;exports.scrollToFirstError = undefined;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _reactRedux = require('react-redux');
var _reactScroll = require('react-scroll');
var _reduxForm = require('redux-form');

var _containers = require('../../containers');






var _components = require('../../components');












var _PublishAuthenticationBlock = require('./PublishAuthenticationBlock');var _PublishAuthenticationBlock2 = _interopRequireDefault(_PublishAuthenticationBlock);
var _PublishFinishBlock = require('./PublishFinishBlock');var _PublishFinishBlock2 = _interopRequireDefault(_PublishFinishBlock);
var _VRLinkBlock = require('./VRLinkBlock');var _VRLinkBlock2 = _interopRequireDefault(_VRLinkBlock);


var _publishProperty = require('../../redux/modules/publishProperty');
var _manageProperties = require('../../redux/modules/manageProperties');





var _propertyDetails = require('../../redux/modules/propertyDetails');
var _findByNeighborhood = require('../../redux/modules/findByNeighborhood');
var _messageModal = require('../../redux/modules/messageModal');
var _payments = require('../../redux/modules/payments');
var _userAuthentication = require('../../redux/modules/userAuthentication');



var _placesGeocode = require('../../redux/modules/placesGeocode');

var _PublishValidate = require('./PublishValidate');var _PublishValidate2 = _interopRequireDefault(_PublishValidate);
var _constants = require('../../constants');







var _PublishPropertyFormConstants = require('./PublishPropertyFormConstants');






var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _publishAnalytics = require('../../helpers/publishAnalytics');var _publishAnalytics2 = _interopRequireDefault(_publishAnalytics);
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _generatePropertyDataForPublish = require('../../helpers/generatePropertyDataForPublish');var _generatePropertyDataForPublish2 = _interopRequireDefault(_generatePropertyDataForPublish);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _checkers = require('../../utils/checkers');
var _packagesData = require('../../packagesData');







var _paymentCalculation = require('../../helpers/paymentCalculation');
var _getVirtualNumberValue = require('../../utils/getVirtualNumberValue');
var _scrollTo = require('../../utils/scrollTo');var _scrollTo2 = _interopRequireDefault(_scrollTo);

var _PublishPropertyPage = require('../../pages/PublishPropertyPage/PublishPropertyPage.scss');var styles = _interopRequireWildcard(_PublishPropertyPage);
var _assetsToDelete = require('../../redux/modules/assetsToDelete');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
_reactScroll.scroller.scrollTo = _scrollTo2.default.bind(_reactScroll.scroller);
var selector = (0, _reduxForm.formValueSelector)('PublishForm');
var registerNewField = function registerNewField(name) {return (0, _reduxForm.registerField)('PublishForm', name, 'Field');};
var unregisterFormField = function unregisterFormField(name) {return (0, _reduxForm.unregisterField)('PublishForm', name);};
var changeValue = function changeValue(name, value) {return (0, _reduxForm.change)('PublishForm', name, value);};
var projectFormValuesSelector = (0, _reduxForm.formValueSelector)('addNewProject');

var ADVICE_TOUT = 10000;

var scrollToFirstError = exports.scrollToFirstError = function scrollToFirstError(errors) {
  var errorKeys = Object.keys(errors);

  if (!errorKeys.length) {
    return null;
  }

  var isMobile = (0, _checkers.isMobileDisplaySize)(global && global.innerWidth);
  var rightOrderedFields = _PublishPropertyFormConstants.publishPropertyRequiredFields.filter(function (field) {return errorKeys.indexOf(field) !== -1;});
  return _reactScroll.scroller.scrollTo(rightOrderedFields[0], {
    duration: 500,
    offset: isMobile ? -(_constants.mobileHeaderHeight + 3) : -(_constants.desktopHeaderHeight + 30),
    smooth: true });

};var

PublishForm = function (_Component) {_inherits(PublishForm, _Component);function PublishForm() {var _temp, _this, _ret;_classCallCheck(this, PublishForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      uploadInProgress: false,
      showAdvice: false,
      isPaymentOpen: false,
      isIframeOpen: false,
      isPinShown: false,
      isLoadedFromDraft: false,
      couponCode: '',
      showProcessOverlay: false,
      isDealType: true,
      isEdit: _this.props.isEdit || _this.props.isEditforeignProject || _this.props.isEditProject }, _this.







































































































































































































































    setCouponCode = function (couponCode) {
      _this.setState(function (prevState) {return Object.assign({}, prevState, { couponCode: couponCode });});
    }, _this.

    setAdviceTimeOut = function () {
      _this.clearAdviceTimeOut();

      if (_this.props.config) {
        if (_this.state.showAdvice) {
          _this.setState({ showAdvice: false });
        }

        return;
      }

      _this.tOut = setTimeout(function () {
        if (!_this.props.config) {
          _this.setState({ showAdvice: true });
        }
      }, ADVICE_TOUT);
    }, _this.

    getSelectedPackageData = function (selectedPackage, isAgent) {
      var packages = (0, _packagesData.getPackages)(isAgent);
      return packages.find(function (pack) {return pack.id === selectedPackage.checked;}) || {};
    }, _this.

    getPackageDataForPayment = function (selectedPackage, isAgent) {var
      period = selectedPackage.period,alternativePeriod = selectedPackage.alternativePeriod;
      var currPackage = _this.getSelectedPackageData(selectedPackage, isAgent);

      var currentPeriod = (0, _get2.default)(currPackage, 'period.' + period) ? period : alternativePeriod;
      var products = (0, _packagesData.buildPackageDataForPayment)(currPackage, currentPeriod);

      if (!!currPackage.type) {
        _this.increaseProductsAmount(products); // TODO Discuss that issue to find a better solution
      }

      return { products: products };
    }, _this.

    withCouponCode = function (requestData) {return _this.state.couponCode ? Object.assign({},
      requestData, { discount_code: _this.state.couponCode }) :
      requestData;}, _this.

    handlePurchase = function (isSuccessPaid, isRequestFailed, transactionId) {
      if (isSuccessPaid) {
        (0, _publishAnalytics2.default)('success/' + isSuccessPaid, 'payment', _this.props);
        _this.purchaseAnalyics(transactionId);
        _this.setState({ isPaymentOpen: false, showProcessOverlay: true });
        return _this.props.verifyPayment({
          data: {
            user_id: _this.props.userAuthentication.data.id,
            locale: _this.props.locale,
            admin: false,
            transactionId: transactionId },

          token: _this.props.token }).

        then(function () {return _this.props.authUserByToken(_this.props.updatedToken);}).
        then(_this.props.handleSubmit(_this.submitForm)).
        then(_this.promoteProperty);
      } else if (isRequestFailed) {
        _this.setState({ isPaymentOpen: false });
        return Promise.
        resolve(_this.props.inquirePayment({
          data: {
            user_id: _this.props.userAuthentication.data.id,
            locale: _this.props.locale,
            admin: false,
            transactionId: transactionId },

          token: _this.props.token })).

        then(_this.props.openMessageModal({
          message:
          _react2.default.createElement(_components.PaymentFailMessage, {
            closeModal: _this.props.hideMessageModal,
            translate: _this.props.parsTranslate('FailModal') }),


          isCloseButtonInvisible: true,
          className: 'failPaymentModal' }));

      }
      window.hideMessageModal = null;
      window.successPayment = null;
      window.failPayment = null;
      window.isDesktop = null;
      return null;
    }, _this.

    changeSelectedPayment = function (env) {
      (0, _publishAnalytics2.default)(env, 'package', _this.props);
      return _this.props.changeSelectedPayment(env);
    }, _this.

    increaseProductsAmount = function (products) {
      var propertiesData = (0, _get2.default)(_this.props, 'manageProperties.data.meta.user_properties');

      products.forEach(function (product) {
        if (product.name === _packagesData.possibleProductNames.AUTO_JUMP) {
          var allowedCount = (0, _get2.default)(propertiesData, 'jump_promotion.allowed') || 0;
          product.amount = allowedCount + 1;
        }

        if (product.name === _packagesData.possibleProductNames.HIGHLIGHT) {
          var _allowedCount = (0, _get2.default)(propertiesData, 'promotion.allowed') || 0;
          product.amount = _allowedCount + 1;
        }

        if (product.name === _packagesData.possibleProductNames.TOP) {
          var _allowedCount2 = (0, _get2.default)(propertiesData, 'top_promotion.allowed') || 0;
          product.amount = _allowedCount2 + 1;
        }
      });
    }, _this.

    checkIsFreePricedPackage = function () {
      var selectedPeriod = (0, _get2.default)(_this.props, 'selectedPackage.period');
      var data = _this.getSelectedPackageData(_this.props.selectedPackage, _this.props.isAgent);
      var price = (0, _get2.default)(data, 'period[' + selectedPeriod + '].price');
      return price === 0;
    }, _this.

    promoteProperty = function () {var _this$props =
      _this.props,isAgent = _this$props.isAgent,paidProducts = _this$props.paidProducts;
      if (isAgent) {return null;}

      var propertyId = (0, _get2.default)(_this.props, 'publishedPropertyData.data.id');
      var ids = [propertyId];
      var products = paidProducts && paidProducts.map(function (_ref) {var name = _ref.name;return name;}) || [];

      if (products.includes(_packagesData.possibleProductNames.AUTO_JUMP)) {
        _this.props.activateAutoJump({
          data: { ids: ids, enable: true },
          token: _this.props.token });

      }

      if (products.includes(_packagesData.possibleProductNames.HIGHLIGHT)) {
        _this.props.updatePropertyHighlighting({
          ids: ids,
          promote: true,
          access_token: _this.props.token });

      }

      if (products.includes(_packagesData.possibleProductNames.TOP)) {
        _this.props.activateTopPromotion({
          data: { ids: ids, enable: true },
          token: _this.props.token });

      }

      return null;
    }, _this.

    saveDataToStorage = function () {
      var isProjects = (0, _get2.default)(_this.props, 'fields.section') === 'projects';
      var storageField = _this.props.isForeign ? 'publishForeignData' : 'publishData';
      var formValues = isProjects ? Object.assign({
        section: 'projects' },
      _this.props.publishProjectFormValues) :
      _this.props.fields;

      _constants.storage.value.setItem(storageField, JSON.stringify(formValues));
    }, _this.

    editProperty = _this.props.isEdit, _this.

    loadFromDraft = function () {
      (0, _publishAnalytics2.default)(true, 'draft', _this.props);
      var storageField = _this.props.isForeign ? 'publishForeignData' : 'publishData';
      _this.props.hideMessageModal();
      _this.loadingFromDraft = true;
      _this.props.initialize(JSON.parse(_constants.storage.value.getItem(storageField)));
      _this.setState({ isLoadedFromDraft: true });
    }, _this.

    clearAdviceTimeOut = function () {
      if (_this.tOut) {
        clearTimeout(_this.tOut);
        _this.tOut = null;
      }
    }, _this.

    changeUploadingStatus = function (uploadInProgress) {return _this.setState({ uploadInProgress: uploadInProgress });}, _this.

    addAssetToDelete = function (_ref2) {var publicId = _ref2.publicId,contentType = _ref2.contentType;
      _this.props.addAssetToDelete({ id: publicId, type: contentType });
    }, _this.
    changeDealType = function () {_this.setState({ isDealType: false });}, _this.
    submitForm = function (values) {var _ref3 =
      _this.props.userAuthentication || {},userData = _ref3.data;

      var currencyValue = values.currency && values.currency.value ?
      values.currency.value :
      values.currency;

      var sendingData = {
        propertyData: (0, _generatePropertyDataForPublish2.default)(Object.assign({},
        values, { currency: currencyValue }),
        _this.props.config,
        userData,
        false,
        _this.props.isEdit,
        _this.props.geocodedPlace),

        access_token: _this.props.token };


      if (!_this.props.isAgent) {
        _this.props.findByNeighborhood({
          city: values.address.en.city_name,
          neighborhood: values.address.en.neighborhood });

      }

      (0, _get2.default)(sendingData, 'propertyData.images', []).
      forEach(function (_ref4) {var link = _ref4.link;return _this.props.addAssetToUnsuspend({ type: 'image', id: link });});

      (0, _get2.default)(sendingData, 'propertyData.videos', []).
      forEach(function (_ref5) {var id = _ref5.id;return _this.props.addAssetToUnsuspend({ type: 'video', id: id });});

      if (_this.props.isEdit) {var
        id = _this.props.editedProperty.id;
        return _this.props.updatePropertyData(Object.assign({}, sendingData, { id: id }));
      }

      if (!_this.props.isEdit && !_this.props.hasPackage) {var _this$props2 =
        _this.props,selectedPackage = _this$props2.selectedPackage,isAgent = _this$props2.isAgent;
        var currentPackageData = _this.getSelectedPackageData(selectedPackage, isAgent);
        var selectedPeriod = (0, _get2.default)(_this.props, 'selectedPackage.period');
        var data = _this.getSelectedPackageData(_this.props.selectedPackage, _this.props.isAgent);
        var price = (0, _get2.default)(data, 'period[' + selectedPeriod + '].price');

        (0, _analyticsManager.trackGTM)({
          name: _analyticsConstants.eventCategory.purchase,
          value: price,
          transactionId: _this.props.transactionId,
          item: currentPackageData.type });


        (0, _analyticsManager.trackGTMPublishPackage)(Object.assign({}, currentPackageData, selectedPackage), isAgent);
      }

      return _this.props.sendPropertyData(Object.assign({}, sendingData));
    }, _this.

    openDetailsToInvoiceForm = function () {
      (0, _publishAnalytics2.default)('invoiceDetails', 'payment', _this.props);
      _this.props.openMessageModal({
        message:
        _react2.default.createElement(_containers.DetailsToInvoiceForm, {
          onSubmit: _this.handleSendPayment,
          selectedPackage: _this.props.selectedPackage,
          currentPackageData: _this.getSelectedPackageData(_this.props.selectedPackage, _this.props.isAgent),
          packages: (0, _packagesData.getPackages)(_this.props.isAgent),
          translate: _this.props.parsTranslate('PurchaseSummery'),
          isMobile: _this.props.isMobile,
          isAgent: _this.props.isAgent,
          discountCoupon: _this.props.discountCoupon }),


        className: 'invoiceModal',
        shouldCloseOnOverlayClick: false });

      _this.setState({
        isPaymentOpen: true,
        isIframeOpen: true });

    }, _this.

    handleSendPayment = function (invoiceDetails) {
      var packages = (0, _packagesData.getPackages)(_this.props.isAgent);
      var packageData = _this.getPackageDataForPayment(_this.props.selectedPackage, _this.props.isAgent);
      var couponType = (0, _get2.default)(_this.props, 'discountCoupon.type');var _calculatePaymentAmou =
      (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(_this.props.selectedPackage, packages, couponType),priceGrand = _calculatePaymentAmou.priceGrand;
      var companyId = (0, _get2.default)(_this.props, 'userAuthentication.data.agent_data.agency_id');
      var userId = (0, _get2.default)(_this.props, 'userAuthentication.data.id');var
      period = _this.props.selectedPackage.period;
      var paymentsNumber = (0, _packagesData.getPaymentsNumber)(period);

      window.hideMessageModal = function () {
        _this.setState({ isIframeOpen: false });
        _this.props.hideMessageModal();
      };
      window.successPayment = _this.props.successPayment;
      window.failPayment = _this.props.failPayment;
      window.isDesktop = !_this.props.isMobile;

      _this.props.sendPaymentRequest({
        data: _this.withCouponCode(Object.assign({},
        packageData,
        invoiceDetails, {
          currency: _packagesData.currency.ILS,
          user_id: userId,
          locale: _this.props.locale,
          payments_number: paymentsNumber,
          amount: priceGrand })),

        token: _this.props.token });

    }, _this.

    shouldRenderAllForm = function (isPinShown) {return _this.setState({ isPinShown: isPinShown });}, _this.













    scrollTo = function () {var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'address';var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true,
        offset: _this.props.isMobile ? -60 : -95 },
      options));

    }, _this.

    scrollToAbout = function (options) {return _this.scrollTo('aboutProperty', options);}, _this.

    phoneVerificationSuccess = function (status) {return status ?
      setTimeout(function () {return _this.props.updateVerification({ phone: true });}, 1000) :
      null;}, _this.

    isAgentWithoutToken = function () {return _this.props.fields.customerType === 'agent' && !_this.props.token;}, _this.

    renderAuthenticationBlock = function () {return (
        _react2.default.createElement(_PublishAuthenticationBlock2.default, {
          isAgent: _this.props.isAgent,
          label: _this.props.translate('sections', 'personalInfo').toString() }));}, _this.




    renderPhoneVerificationBlock = function () {return (
        _react2.default.createElement('div', { className: styles.authenticationBlock },
          _react2.default.createElement('div', { className: styles.blockTitle }, _this.props.translate('phoneVerificationTitle')),
          _react2.default.createElement(_containers.PhoneVerificationContainer, {
            verificationSuccess: _this.phoneVerificationSuccess,
            isPublishForm: true })));}, _this.



















































    renderUploadWidget = function (_ref6) {var meta = _ref6.meta;var _this$props3 =
      _this.props,translate = _this$props3.translate,isMobile = _this$props3.isMobile,config = _this$props3.config,fields = _this$props3.fields,locale = _this$props3.locale,token = _this$props3.token;
      var parameters = { translate: translate, isMobile: isMobile, config: config, locale: locale };

      return (
        _react2.default.createElement(_components.UploadPhotoBlock, _extends({},
        parameters, {
          rootTranslate: _this.props.rootTranslate,
          images: fields.images || [],
          videos: fields.videos || [],
          registerNewField: _this.props.registerNewField,
          changeValue: _this.props.changeValue,
          changeUploadingStatus: _this.changeUploadingStatus,
          addAssetToDelete: _this.addAssetToDelete,
          className: styles.uploadPhotoBlock,
          error: _this.props.error,
          uploadImageTimeout: _this.props.uploadImageTimeout,
          openMessageModal: _this.props.openMessageModal,
          token: token,
          isInvalid: meta.touched && meta.error && !meta.active,
          showRequiredImagesTooltip: !!meta.error })));


    }, _this.





































































































































    renderSegmentedControl = function (name, values, selectedValue, rowLabel, theme) {return (
        _react2.default.createElement('div', { className: styles.formRow },
          _react2.default.createElement('span', { className: styles.rowLabel }, rowLabel || ''),

          _react2.default.createElement('div', { className: 'fieldset' },
            _react2.default.createElement(_components.OMSegmentedControl, {
              inReduxForm: true,
              name: name,
              values: values,
              selectedValue: selectedValue,
              className: 'rounded',
              theme: theme }))));}, _this.






































    renderContactUsForm = function () {
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.publish, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.projectsSection);var _this$props4 =









      _this.props,location = _this$props4.location,manageProperties = _this$props4.manageProperties,isEditProject = _this$props4.isEditProject,isEditforeignProject = _this$props4.isEditforeignProject,uploadImageTimeout = _this$props4.uploadImageTimeout,changeAddProperty = _this$props4.changeAddProperty,isAgent = _this$props4.isAgent,isForeign = _this$props4.isForeign;

      return (
        _react2.default.createElement(_containers.PublishNewHomesFormComponent, {
          isRealtor: isAgent,
          isLoadedFromDraft: _this.state.isLoadedFromDraft,
          isForeign: isForeign || isEditforeignProject,
          location: location,
          changeAddProperty: changeAddProperty,
          changeDealType: _this.changeDealType,
          editedProject: manageProperties.editedProject,
          isEditProject: isEditProject || isEditforeignProject,
          uploadImageTimeout: uploadImageTimeout,
          openMessageModal: _this.props.openMessageModal }));


    }, _this.


















    renderAdvertismentBlock = function () {var _this$props5 =






      _this.props,isForeign = _this$props5.isForeign,isMobile = _this$props5.isMobile,translate = _this$props5.translate,fields = _this$props5.fields,token = _this$props5.token;
      var isAgentWithoutToken = fields.customerType === 'agent' && !token;
      var publishConfigSections = [].concat(_constants.publishConfig.sections, ['projects']);

      var title = function title() {
        if (_this.props.isAddProperty) {
          return translate('propertyHeadTitle');
        } else if (isMobile) {
          return translate('headTitle');
        }

        return translate('sections', 'advertisement');
      };

      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_components.OMTitle, {
            title: title(),
            className: 'publishTitle' }),

          !token &&
          _react2.default.createElement('div', { className: styles.customerType },
            _this.renderSegmentedControl(
            'customerType',
            (0, _PublishPropertyFormConstants.getCustomerTypes)(translate),
            fields.customerType,
            translate('customerType'),
            'green')),




          (token || fields.customerType) && !isAgentWithoutToken && _this.state.isDealType &&
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.formRow, styles.sectionsBlock) },
            _react2.default.createElement('span', { className: styles.rowLabel }, translate('typeOfTransaction')),
            _react2.default.createElement('div', { className: (0, _classnames2.default)('fieldset', styles.topSegmentedControl) },
              _react2.default.createElement('i', { className: 'icon icon-projects' }),
              _react2.default.createElement(_components.OMSegmentedControl, {
                inReduxForm: true,
                name: 'section',
                values: publishConfigSections.map(function (section) {return {
                    value: section,
                    label: translate('initialPropertyDetailsSection', section) };}),

                selectedValue: fields.section,
                className: 'rounded' })))));






    }, _temp), _possibleConstructorReturn(_this, _ret);}PublishForm.prototype.componentWillMount = function componentWillMount() {var _this2 = this;if (this.props.editedProperty) {var _props$editedProperty = this.props.editedProperty,section = _props$editedProperty.section,optionType = _props$editedProperty.search_option;this.props.getPropertyTypesValues({ section: section, optionType: optionType });} else {var defaultPackage = (0, _packagesData.getDefaultSelectedPackage)(this.props.isAgent);this.props.changeSelectedPayment(defaultPackage);var foreignPropertiesActive = (0, _get2.default)(this.props, 'userAuthentication.data.foreignProperties.active', null);var foreignPropertiesAllowed = (0, _get2.default)(this.props, 'userAuthentication.data.foreignProperties.allowed', null);var userHasForeignPublishPermission = (0, _get2.default)(this.props, 'userAuthentication.data.publish_permissions.foreign', null);var allowedForeignCount = (0, _get2.default)(this.props, 'userProperties.data.meta.user_foreign_properties.allowed');var activeForeignCount = (0, _get2.default)(this.props, 'userProperties.data.meta.user_foreign_properties.active');var isOnForeignPublishPage = this.props.routeData.location === 'foreign_publish';var storageField = this.props.isForeign ? 'publishForeignData' : 'publishData';var isStorageValueSet = _constants.storage.value.getItem(storageField);var isEditingProject = this.props.isEditProject || this.props.isEditforeignProject;var foreignPropertiesLimitReached = isOnForeignPublishPage && !(foreignPropertiesActive < foreignPropertiesAllowed);var shouldBlockPublishForeign = isOnForeignPublishPage && !userHasForeignPublishPermission;var foreignPropertiesWithinLimit = isOnForeignPublishPage && allowedForeignCount <= activeForeignCount;var isForeignPublishAllowed = foreignPropertiesWithinLimit || shouldBlockPublishForeign || foreignPropertiesLimitReached;if (isStorageValueSet && !isEditingProject && !isForeignPublishAllowed) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: styles.loadFromDraftMsg }, _react2.default.createElement('p', null, this.props.translate('wantToContinue')), _react2.default.createElement(_components.OMPrimaryButton, { title: this.props.translate('editDraft'), clickHandler: this.loadFromDraft }), _react2.default.createElement(_components.OMClearButton, { clickHandler: function clickHandler() {(0, _publishAnalytics2.default)(false, 'draft', _this2.props);_constants.storage.value.removeItem(storageField);_this2.props.hideMessageModal();}, title: this.props.translate('newAd') })) });}}};PublishForm.prototype.componentDidMount = function componentDidMount() {this.setAdviceTimeOut();};PublishForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref7) {var _this3 = this;var config = _ref7.config,fetchingData = _ref7.fetchingData,userAuthentication = _ref7.userAuthentication,fields = _ref7.fields,submitSucceeded = _ref7.submitSucceeded,redirectUrl = _ref7.redirectUrl,isMessageModalOpen = _ref7.isMessageModalOpen,transactionId = _ref7.transactionId,isRequestFailed = _ref7.isRequestFailed,isSuccessPaid = _ref7.isSuccessPaid,paidProducts = _ref7.paidProducts,publishedPropertyData = _ref7.publishedPropertyData,paymentError = _ref7.paymentError,published = _ref7.published,isPublishFailed = _ref7.isPublishFailed,selectedPackage = _ref7.selectedPackage;(0, _publishAnalytics2.default)(fields, 'fields', this.props);if (!this.props.paymentError && paymentError) {(0, _publishAnalytics2.default)(paymentError, 'payment', this.props);this.props.openMessageModal({ message: this.props.parsTranslate('FailModal', 'title') });}if (selectedPackage.checked !== this.props.selectedPackage.checked) {this.props.changeValue('selectedPackage', selectedPackage.checked);}if (fields.section !== this.props.fields.section) {this.props.changeNavigator(fields.section !== 'projects');}var publishIsFailed = isPublishFailed && isPublishFailed !== this.props.isPublishFailed;var publishSucceeded = published && published !== this.props.published;if (publishIsFailed || publishSucceeded) {this.setState({ showProcessOverlay: false });}if (this.state.isPaymentOpen && !this.state.isIframeOpen && !isMessageModalOpen && this.props.isMessageModalOpen) {return this.handlePurchase(isSuccessPaid, isRequestFailed, transactionId);}var data = userAuthentication.data;this.setAdviceTimeOut();var section = fields.section,optionType = fields.search_option,subOption = fields.sub_option,propertyType = fields.property_type;var newOptionType = optionType === _constants.optionTypes.buy ? optionType : subOption;var storageField = this.props.isForeign ? 'publishForeignData' : 'publishData';if (this.loadingFromDraft) {if (section && optionType) {this.props.getPropertyTypesValues({ section: section, optionType: optionType });propertyType && this.props.getFieldsConfig({ section: section, optionType: newOptionType, propertyType: propertyType });}this.loadingFromDraft = false;return true;}if (!this.props.submitSucceeded && submitSucceeded && _constants.storage.value.getItem(storageField)) {_constants.storage.value.removeItem(storageField);this.props.clearPaymentData();}var _props$fields = this.props.fields,currentOptionType = _props$fields.search_option,currentSubOption = _props$fields.sub_option,currentPropertyType = _props$fields.property_type,currentSection = _props$fields.section;if (data && !this.props.userAuthentication.data) {var defaultSelectedPackage = (0, _packagesData.getDefaultSelectedPackage)(data.is_agent);this.props.changeSelectedPayment(defaultSelectedPackage);if (data.display_name) {this.props.changeValue('contacts.primary.name', data.display_name);}if (data.email) {this.props.changeValue('contacts.primary.email', data.email);}if (data.phone_number && !data.virtual_numbers) {this.props.changeValue('contacts.primary.phone', data.phone_number);}}if (this.props.isMobile) {var sectionIsChanged = currentSection !== section;var optionIsChanged = currentOptionType !== optionType;var typeIsChanged = currentPropertyType !== propertyType;if (sectionIsChanged) {this.scrollTo('advertisement', { offset: -65 });}if (!sectionIsChanged && optionType && optionIsChanged) {this.scrollTo('advertisement', { offset: -25 });}}if (fetchingData) {return null;} // Algorithm: select section => select optionType => fetch propertyType => select propertyType => fetch config => render full form
    if (currentSection && currentSection !== section) {this.props.change('property_type', '');this.props.change('address', '');return this.props.change('search_option', '');}var isSectionChanged = currentSection && currentSection !== section;var isOptionSelectedFirstTime = !currentOptionType && optionType;var isOptionChanged = currentOptionType !== optionType;var isSubOptionChanged = currentSubOption !== subOption;var isAnySearchOptionsChanged = optionType && (isOptionChanged || isSubOptionChanged); // First time select option type or option type change
    if (isSectionChanged || section && (isOptionSelectedFirstTime || isAnySearchOptionsChanged)) {// Reset property type if selected and than fetch property type
      return Promise.resolve(propertyType).then(function (propType) {return !!propType && _this3.props.change('property_type', '');}).then(function () {return _this3.props.getPropertyTypesValues({ section: section, optionType: newOptionType });});} // First time load config or property type change or edit property config initialization
    if (section && optionType && (!currentPropertyType && propertyType || propertyType && currentPropertyType !== propertyType || propertyType && !config)) {return this.props.getFieldsConfig({ section: section, optionType: newOptionType, propertyType: propertyType }).then(function () {return !_this3.props.isEdit && _this3.scrollTo('address');});}if (this.props.redirectUrl !== redirectUrl) {this.props.openMessageModal({ message: _react2.default.createElement('iframe', { id: 'payment-iframe', src: redirectUrl, title: 'payments' }, _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })), className: 'invoiceModal', shouldCloseOnOverlayClick: false });this.setState({ isPaymentOpen: true, isIframeOpen: true });}return null;};PublishForm.prototype.componentWillUnmount = function componentWillUnmount() {this.clearAdviceTimeOut();if (this.props.submitFailed || !this.props.published && !this.state.isEdit) {var isSection = (0, _get2.default)(this.props, 'fields.section');var values = Object.values(this.props.fields).filter(function (field) {return field && (typeof field === 'undefined' ? 'undefined' : _typeof(field)) !== 'object';});!this.state.isLoadedFromDraft && isSection && this.saveDataToStorage();this.props.clearPaymentData();}this.props.resetGeocodedPlace();};PublishForm.prototype.purchaseAnalyics = function purchaseAnalyics(transactionId) {var _props = this.props,selectedPackage = _props.selectedPackage,isAgent = _props.isAgent;var packages = (0, _packagesData.getPackages)(isAgent);var couponType = (0, _get2.default)(this.props, 'discountCoupon.type');var _calculatePaymentAmou2 = (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(selectedPackage, packages, couponType),priceGrand = _calculatePaymentAmou2.priceGrand,tax = _calculatePaymentAmou2.tax;var currentPackageData = this.getSelectedPackageData(selectedPackage, this.props.isAgent);var period = (0, _get2.default)(selectedPackage, 'period', 1);var propertiesCount = (0, _get2.default)(currentPackageData, 'properties', 1);var type = (0, _get2.default)(currentPackageData, 'type', propertiesCount + ' properties ' + period + 'M');(0, _analyticsManager.trackEcommerce)(transactionId, type, priceGrand, tax, isAgent ? 'agent' : 'user', 1);};PublishForm.prototype.renderFinishBlock = function renderFinishBlock() {var _props2 = this.props,translate = _props2.translate,isEdit = _props2.isEdit,isMobile = _props2.isMobile,locale = _props2.locale,fields = _props2.fields,routeData = _props2.routeData,editedProperty = _props2.editedProperty,isPublish = _props2.isPublish,hasPackage = _props2.hasPackage,isAgent = _props2.isAgent,isForeign = _props2.isForeign;var isForeignPublish = this.props.routeData.location === 'foreign_publish';var shouldRenderPackagesBlock = !isForeignPublish && isPublish && (!isAgent || !hasPackage);var isFreePackage = this.checkIsFreePricedPackage();var virtualNumbers = (0, _get2.default)(this.props, 'userAuthentication.data.virtual_numbers');return _react2.default.createElement(_PublishFinishBlock2.default, { translate: translate, parsTranslate: this.props.parsTranslate, isMobile: isMobile, locale: locale, isRtl: this.props.isRtl, isEdit: isEdit, isAgent: isAgent, isForeign: isForeign, propertyId: this.props.propertyId, shouldRenderPackagesBlock: shouldRenderPackagesBlock, isFreePackage: isFreePackage, editedProperty: editedProperty, selectedPackage: this.props.selectedPackage, userData: (0, _get2.default)(this.props, 'userAuthentication.data'), geocodedPlace: this.props.geocodedPlace, config: this.props.config, changeValue: this.props.changeValue, saveDataToStorage: this.saveDataToStorage, changeSelectedPayment: this.changeSelectedPayment, setCouponCode: this.setCouponCode, openPreviewDetailsPopup: this.props.openPreviewDetailsPopup, openDetailsToInvoiceForm: this.openDetailsToInvoiceForm, submitForm: this.submitForm, fields: fields, virtualNumbers: virtualNumbers, isSuccessPaid: this.props.isSuccessPaid, isRequestFailed: this.props.isRequestFailed, iframeLoading: this.props.iframeLoading, discountCoupon: this.props.discountCoupon, unregisterFormField: this.props.unregisterFormField, uploadInProgress: this.state.uploadInProgress });};PublishForm.prototype.renderConfigBlock = function renderConfigBlock() {var _props3 = this.props,translate = _props3.translate,isMobile = _props3.isMobile,config = _props3.config,fields = _props3.fields,datePickerTranslates = _props3.datePickerTranslates,locale = _props3.locale,isRtl = _props3.isRtl,isForeign = _props3.isForeign;var parameters = { translate: translate, isMobile: isMobile, config: config, locale: locale };var propertyFields = (0, _pick2.default)(fields, _PublishPropertyFormConstants.aboutPropertyBlockFields);var priceFields = (0, _pick2.default)(fields, _PublishPropertyFormConstants.priceBlockFields);var isFullAddress = (0, _get2.default)(fields.address, 'isFull');var isCityName = (0, _get2.default)(fields, 'address.en.city_name') || (0, _get2.default)(fields, 'address.he.city_name');var isCountryName = (0, _get2.default)(fields, 'address.en.country_name') || (0, _get2.default)(fields, 'address.he.country_name');var showConfigBlock = isForeign ? config && isCityName && isCountryName : config && fields.address && isFullAddress && !this.isAgentWithoutToken();if (!showConfigBlock) {return null;}return _react2.default.createElement('div', null, _react2.default.createElement(_containers.AboutPropertyBlock, _extends({}, parameters, { fields: propertyFields, isRtl: isRtl, changeValue: this.props.changeValue, registerNewField: this.props.registerNewField, searchOption: fields.search_option, isForeign: this.props.isForeign })), _react2.default.createElement(_containers.AboutBuildingBlock, _extends({}, parameters, { elevators: fields.elevators, isForeign: this.props.isForeign })), _react2.default.createElement(_reactScroll.Element, { name: 'images' }, _react2.default.createElement(_reduxForm.Field, { name: 'images', props: { locale: this.props.locale }, component: this.renderUploadWidget }), _react2.default.createElement(_VRLinkBlock2.default, { translate: translate, locale: locale })), config.description && _react2.default.createElement(_components.DescriptionBlock, { fields: fields, translate: translate, props: { locale: locale } }), _react2.default.createElement(_components.PriceBlock, _extends({}, parameters, { rentOption: this.props.fields.sub_option, fields: priceFields, registerNewField: this.props.registerNewField, changeValue: this.props.changeValue, datePickerTranslates: datePickerTranslates, isForeign: this.props.isForeign })));};PublishForm.prototype.renderPropertyTypes = function renderPropertyTypes() {if (this.props.calcReportButtonPosition) {this.props.calcReportButtonPosition();}var _props4 = this.props,fields = _props4.fields,propertyTypes = _props4.propertyTypes,rootTranslate = _props4.rootTranslate;var filteredProperTypes = fields.search_option === _constants.optionTypes.rent ? propertyTypes : propertyTypes.filter(function (item) {return item.name !== 'room';});return _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.formRow, styles.propTypesBlock) }, _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelTop, styles.rowLabel) }, this.props.translate('propertyType'), _react2.default.createElement('span', { className: 'req' }, '*')), _react2.default.createElement(_components.OMRadioButtons, { name: 'property_type', values: filteredProperTypes.map(function (item) {return { value: item.name, label: rootTranslate('propertyTypes', item.name) };}), className: styles.flexWrap }));};PublishForm.prototype.renderAddressBlock = function renderAddressBlock() {var _props5 = this.props,translate = _props5.translate,isMobile = _props5.isMobile,config = _props5.config,fields = _props5.fields,locale = _props5.locale,isEdit = _props5.isEdit,editedProperty = _props5.editedProperty,error = _props5.error,anyTouched = _props5.anyTouched,isRtl = _props5.isRtl,reportIssue = _props5.reportIssue,isAgent = _props5.isAgent,token = _props5.token;var address = fields.address;var parameters = { translate: translate, isMobile: isMobile, config: config, fields: fields, locale: locale, error: error, anyTouched: anyTouched, isRtl: isRtl, reportIssue: reportIssue };var showAddressBlock = config && config.addressSearch && fields.property_type && !this.isAgentWithoutToken();if (!showAddressBlock) {return null;}return _react2.default.createElement(_reactScroll.Element, { name: 'address' }, _react2.default.createElement(_components.PublishAddressBlock, _extends({}, parameters, { value: address, name: 'address', error: error && error.address, changeValue: this.props.changeValue, initialValue: isEdit && editedProperty ? editedProperty.address : {}, isRealtor: isAgent, receiveGeocodedPlace: this.props.receiveGeocodedPlace, geocodedPlace: this.props.geocodedPlace, geocodeFailed: this.props.geocodeFailed, shouldRenderAllForm: this.shouldRenderAllForm, isPinNeeds: this.state.isLoadedFromDraft || this.editProperty, isMobile: this.props.isMobile, scrollToAddress: this.scrollToAbout, token: token, isForeign: this.props.isForeign, rootTranslate: this.props.rootTranslate, isPublishFrom: true })));};PublishForm.prototype.renderOptionTypes = function renderOptionTypes() {var _props6 = this.props,_props6$fields = _props6.fields,searchOption = _props6$fields.search_option,subOption = _props6$fields.sub_option,propertyTypes = _props6.propertyTypes,translate = _props6.translate;var options = _constants.publishConfig.optionTypes.map(function (opType) {return { value: opType, label: translate('advertisementTypes', opType) };});var subOptions = _constants.publishConfig.optionTypes.map(function (opType) {return { value: opType, label: translate('subOptionValues', opType) };});var optionValues = options.filter(function (_ref8) {var value = _ref8.value;return value !== _constants.optionTypes['rent-short'];});var subOptionValues = subOptions.filter(function (_ref9) {var value = _ref9.value;return value !== _constants.optionTypes.buy;});return _react2.default.createElement('div', null, this.renderSegmentedControl('search_option', optionValues, searchOption), searchOption === _constants.optionTypes.rent && this.renderSegmentedControl('sub_option', subOptionValues, subOption), searchOption && propertyTypes && this.renderPropertyTypes());};PublishForm.prototype.renderForm = function renderForm() {var _props7 = this.props,_props7$fields = _props7.fields,customerType = _props7$fields.customerType,section = _props7$fields.section,token = _props7.token;var isAgentWithoutToken = customerType === 'agent' && !token;if (!section || isAgentWithoutToken) {return null;}switch (this.props.fields.section) {case 'projects':{return true;}default:return this.renderOptionTypes();}};PublishForm.prototype.render = function render() {var _props8 = this.props,fields = _props8.fields,translate = _props8.translate,token = _props8.token,config = _props8.config,userAuthentication = _props8.userAuthentication,isAgent = _props8.isAgent,isForeign = _props8.isForeign;var address = fields.address,section = fields.section;
    var isProjects = section === 'projects';
    var phoneIsVerified = (0, _get2.default)(userAuthentication, 'data.verification.phone');
    var isAgentWithoutToken = fields.customerType === 'agent' && !token;
    var isCityName = (0, _get2.default)(fields, 'address.en.city_name') || (0, _get2.default)(fields, 'address.he.city_name');
    var isCountryName = (0, _get2.default)(fields, 'address.en.country_name') || (0, _get2.default)(fields, 'address.he.country_name');
    var finishSection = token && (
    isAgent || phoneIsVerified ?
    this.renderFinishBlock() :
    this.renderPhoneVerificationBlock());


    var showFinishPublishSection = isForeign ? isCityName && isCountryName : (0, _get2.default)(address, 'isFull');

    return (
      _react2.default.createElement('div', { className: styles.publishFormWrapper },
        _react2.default.createElement('form', null,
          _react2.default.createElement(_reactScroll.Element, { name: 'anchor-top' }),
          _react2.default.createElement(_reactScroll.Element, { name: 'advertisement' },
            this.renderAdvertismentBlock(),
            this.renderForm()),


          this.renderAddressBlock(),

          this.renderConfigBlock(),

          this.state.showAdvice && !isProjects && !isAgentWithoutToken &&
          _react2.default.createElement('div', { className: styles.advice },
            _react2.default.createElement('span', null, translate('advice'))),


          _react2.default.createElement(_components.PublishProcessOverlay, {
            translate: translate,
            isOpen: this.state.showProcessOverlay })),


        this.props.fields.section === 'projects' && !isAgentWithoutToken && this.renderContactUsForm(),
        (config && address && showFinishPublishSection || isAgentWithoutToken) &&
        _react2.default.createElement('div', { className: styles.finishPublishSection },
          token ? finishSection : this.renderAuthenticationBlock())));




  };return PublishForm;}(_react.Component);


PublishForm.propTypes = {
  fields: _propTypes2.default.object,
  translate: _propTypes2.default.func.isRequired,
  rootTranslate: _propTypes2.default.func.isRequired,
  datePickerTranslates: _propTypes2.default.func.isRequired,
  parsTranslate: _propTypes2.default.func.isRequired,
  getPropertyTypesValues: _propTypes2.default.func.isRequired,
  getFieldsConfig: _propTypes2.default.func.isRequired,
  propertyTypes: _propTypes2.default.any,
  locale: _propTypes2.default.string.isRequired,
  config: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  registerNewField: _propTypes2.default.func,
  unregisterFormField: _propTypes2.default.func,
  untouch: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  isEdit: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func,
  sendPropertyData: _propTypes2.default.func.isRequired,
  findByNeighborhood: _propTypes2.default.func,
  error: _propTypes2.default.object,
  anyTouched: _propTypes2.default.bool,
  submitting: _propTypes2.default.bool,
  editedProperty: _propTypes2.default.object,
  updatePropertyData: _propTypes2.default.func.isRequired,
  openPreviewDetailsPopup: _propTypes2.default.func.isRequired,
  propertyId: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  userAuthentication: _propTypes2.default.object.isRequired,
  clearFieldsConfig: _propTypes2.default.func.isRequired,
  reset: _propTypes2.default.func.isRequired,
  fetchingData: _propTypes2.default.bool,
  reportIssue: _propTypes2.default.func,
  calcReportButtonPosition: _propTypes2.default.func,
  change: _propTypes2.default.func,
  published: _propTypes2.default.bool.isRequired,
  openMessageModal: _propTypes2.default.func.isRequired,
  hideMessageModal: _propTypes2.default.func.isRequired,
  initialize: _propTypes2.default.func.isRequired,
  submitSucceeded: _propTypes2.default.bool,
  submitFailed: _propTypes2.default.bool,
  uploadImageTimeout: _propTypes2.default.func,
  isPublish: _propTypes2.default.bool.isRequired,
  hasPackage: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  sendPaymentRequest: _propTypes2.default.func.isRequired,
  redirectUrl: _propTypes2.default.string,
  verifyPayment: _propTypes2.default.func.isRequired,
  inquirePayment: _propTypes2.default.func.isRequired,
  isMessageModalOpen: _propTypes2.default.bool.isRequired,
  handleShareClick: _propTypes2.default.func,
  transactionId: _propTypes2.default.string,
  authUserByToken: _propTypes2.default.func.isRequired,
  selectedPackage: _propTypes2.default.object,
  publishedPropertyData: _propTypes2.default.object,
  manageProperties: _propTypes2.default.object,
  paidProducts: _propTypes2.default.array,
  changeSelectedPayment: _propTypes2.default.func.isRequired,
  iframeLoading: _propTypes2.default.bool.isRequired,
  successPayment: _propTypes2.default.func,
  failPayment: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  addAssetToUnsuspend: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  activateAutoJump: _propTypes2.default.func,
  activateTopPromotion: _propTypes2.default.func,
  isPublishFailed: _propTypes2.default.bool,
  isRequestFailed: _propTypes2.default.bool,
  isSuccessPaid: _propTypes2.default.bool,
  paymentError: _propTypes2.default.object,
  discountCoupon: _propTypes2.default.object,
  clearPaymentData: _propTypes2.default.func.isRequired,
  receiveGeocodedPlace: _propTypes2.default.func.isRequired,
  resetGeocodedPlace: _propTypes2.default.func,
  updateVerification: _propTypes2.default.func,
  geocodedPlace: _propTypes2.default.object,
  location: _propTypes2.default.object,
  geocodeFailed: _propTypes2.default.bool,
  isEditProject: _propTypes2.default.bool,
  isEditforeignProject: _propTypes2.default.bool,
  updatedToken: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool,
  changeNavigator: _propTypes2.default.func,
  changeAddProperty: _propTypes2.default.func,
  isAddProperty: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  userProperties: _propTypes2.default.object,
  publishProjectFormValues: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(_ref10, _ref11)

















{var isForeign = _ref11.isForeign;var _ref10$publishPropert = _ref10.publishProperty,propertyTypes = _ref10$publishPropert.propertyTypes,config = _ref10$publishPropert.config,fetchingData = _ref10$publishPropert.fetchingData,published = _ref10$publishPropert.published,error = _ref10$publishPropert.error,data = _ref10$publishPropert.data,userAuthentication = _ref10.userAuthentication,routing = _ref10.routing,manageProperties = _ref10.manageProperties,payments = _ref10.payments,messageModal = _ref10.messageModal,placesGeocode = _ref10.placesGeocode,discountCoupon = _ref10.discountCoupon,lang = _ref10.lang,args = _objectWithoutProperties(_ref10, ['publishProperty', 'userAuthentication', 'routing', 'manageProperties', 'payments', 'messageModal', 'placesGeocode', 'discountCoupon', 'lang']);
  var route = routing.locationBeforeTransitions.pathname;
  var editIdx = route.indexOf('/property/edit');
  var editProjectIdx = route.indexOf('/project/edit');
  var editForeignProjectIdx = route.indexOf('/foreign_project/edit');
  var publishIdx = route.indexOf('/publish');
  var editForeignIdx = route.indexOf('/foreign_property/edit');
  var publishForeignIdx = route.indexOf('/foreign_publish');
  var isEdit = editIdx === 0 || editIdx === 3 ||
  editForeignIdx === 0 || editForeignIdx === 3;
  var isEditProject = editProjectIdx === 0 || editProjectIdx === 3;
  var isEditforeignProject = editForeignProjectIdx === 0 || editForeignProjectIdx === 3;
  var isPublish = publishIdx === 0 || publishIdx === 3 ||
  publishForeignIdx === 0 || publishForeignIdx === 3;
  var editedProperty = manageProperties ? manageProperties.editedProperty : null;
  var editedProject = manageProperties ? manageProperties.editedProject : null;
  var virtualNumbers = (0, _get2.default)(userAuthentication, 'data.virtual_numbers');
  var virtualNumbersLength = (0, _get2.default)(userAuthentication, 'data.virtual_numbers.length');

  return {
    fields: {
      customerType: selector(args, 'customerType'),
      section: selector(args, 'section'),
      search_option: selector(args, 'search_option'),
      sub_option: selector(args, 'sub_option') || _constants.optionTypes.rent,
      property_type: selector(args, 'property_type'),
      address: selector(args, 'address'),
      area: selector(args, 'area'),
      rooms: selector(args, 'rooms'),
      floor: selector(args, 'floor'),
      groundFloor: selector(args, 'groundFloor'),
      parking: selector(args, 'parking'),
      balconies: selector(args, 'balconies'),
      bathrooms: selector(args, 'bathrooms'),
      toilets: selector(args, 'toilets'),
      construction_year: selector(args, 'construction_year'),
      light_direction: selector(args, 'light_direction'),
      elevators: selector(args, 'elevators'),
      description: selector(args, 'description'),
      price: selector(args, 'price'),
      entry_date: selector(args, 'entry_date'),
      contacts: selector(args, 'contacts'),
      payments: selector(args, 'payments'),
      images: selector(args, 'images'),
      videos: selector(args, 'videos'),
      hasBasement: selector(args, 'hasBasement'),
      commodities: selector(args, 'commodities'),
      balconies_area: selector(args, 'balconies_area'),
      currency: selector(args, 'currency') },

    initialValues: isEdit && editedProperty ? Object.assign({

      section: editedProperty.section,
      search_option: editedProperty.search_option === _constants.optionTypes['rent-short'] ? _constants.optionTypes.rent : editedProperty.search_option,
      sub_option: editedProperty.search_option !== _constants.optionTypes.buy ? editedProperty.search_option : _constants.optionTypes.rent,
      property_type: editedProperty.property_type,
      address: editedProperty.address,
      price: editedProperty.price,
      commodities: editedProperty.commodities,
      description: editedProperty.description,
      images: editedProperty.images,
      vr_link: editedProperty.vr_link,
      videos: editedProperty.videos,
      light_direction: editedProperty.light_direction,
      contacts: {
        primary: editedProperty.contacts.primary && Object.assign({},
        editedProperty.contacts.primary, {
          virtual: (0, _getVirtualNumberValue.getVirtualNumberValue)(editedProperty.contacts.primary, virtualNumbers),
          phone: (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(editedProperty.contacts.primary.phone)) }),

        secondary: editedProperty.contacts.secondary && Object.assign({},
        editedProperty.contacts.secondary, {
          virtual: (0, _getVirtualNumberValue.getVirtualNumberValue)(editedProperty.contacts.secondary, virtualNumbers),
          phone: (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(editedProperty.contacts.secondary.phone)) }) },


      currency: editedProperty.currency || _PublishPropertyFormConstants.currencies.ILS },
    editedProperty.additional_info) :

    {
      section: editedProject && (isEditProject || isEditforeignProject) ? 'projects' : null,
      area: {
        base: null },

      floor: {
        on_the: null,
        out_of: null },

      contacts: {
        primary: {
          // email: userAuthentication.data ? userAuthentication.data.email : null,
          name: userAuthentication.data ? userAuthentication.data.display_name : null,
          phone: userAuthentication.data && userAuthentication.data.phone_number && !virtualNumbersLength ?
          (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(userAuthentication.data.phone_number)) : null } },


      currency: isForeign ? _PublishPropertyFormConstants.currencies.USD : _PublishPropertyFormConstants.currencies.ILS },

    propertyId: isEdit && editedProperty ? editedProperty.id : null,
    isAgent: userAuthentication.data ? (0, _get2.default)(userAuthentication, 'data.is_agent') : selector(args, 'customerType') === 'agent',
    editedProperty: editedProperty,
    userAuthentication: userAuthentication,
    propertyTypes: propertyTypes,
    isPublish: isPublish,
    isEdit: isEdit,
    config: config,
    fetchingData: fetchingData,
    published: published,
    isForeign: isForeign,
    isEditProject: isEditProject,
    isEditforeignProject: isEditforeignProject,
    isPublishFailed: !!error,
    manageProperties: manageProperties,
    publishedPropertyData: data,
    redirectUrl: payments.redirectUrl,
    paymentError: payments.error,
    transactionId: payments.transactionId,
    paidProducts: payments.paidProducts,
    updatedToken: payments.updatedToken,
    selectedPackage: payments.selectedPackage,
    iframeLoading: payments.iframeLoading,
    isSuccessPaid: payments.isSuccessPaid,
    isRequestFailed: payments.isRequestFailed,
    isMessageModalOpen: messageModal.isMessageModalOpen,
    discountCoupon: discountCoupon.data,
    geocodedPlace: placesGeocode.geocodedPlace,
    geocodeFailed: !!placesGeocode.error || placesGeocode.geocodedPlace === null,
    publishProjectFormValues: projectFormValuesSelector.apply(undefined, [args].concat(_constants.publishProjectFormFieldsForSave)) };

};

var mapDispatchToProps = {
  getPropertyTypesValues: _publishProperty.getPropertyTypesValues,
  getFieldsConfig: _publishProperty.getFieldsConfig,
  registerNewField: registerNewField,
  unregisterFormField: unregisterFormField,
  changeValue: changeValue,
  findByNeighborhood: _findByNeighborhood.findByNeighborhood,
  sendPropertyData: _publishProperty.sendPropertyData,
  updatePropertyData: _manageProperties.updatePropertyData,
  openPreviewDetailsPopup: _propertyDetails.openPreviewDetailsPopup,
  clearFieldsConfig: _publishProperty.clearFieldsConfig,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  updateVerification: _userAuthentication.updateVerification,
  sendPaymentRequest: _payments.sendPaymentRequest,
  verifyPayment: _payments.verifyPayment,
  inquirePayment: _payments.inquirePayment,
  authUserByToken: _userAuthentication.authUserByToken,
  changeSelectedPayment: _payments.changeSelectedPayment,
  successPayment: _payments.successPayment,
  failPayment: _payments.failPayment,
  clearPaymentData: _payments.clearPaymentData,
  addAssetToDelete: _assetsToDelete.addAssetToDelete,
  addAssetToUnsuspend: _assetsToDelete.addAssetToUnsuspend,
  updatePropertyHighlighting: _manageProperties.updatePropertyHighlighting,
  activateAutoJump: _manageProperties.activateAutoJump,
  activateTopPromotion: _manageProperties.activateTopPromotion,
  receiveGeocodedPlace: _placesGeocode.receiveGeocodedPlace,
  resetGeocodedPlace: _placesGeocode.resetGeocodedPlace };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps),
(0, _reduxForm.reduxForm)({
  form: 'PublishForm',
  validate: _PublishValidate2.default,
  enableReinitialize: global.location && (global.location.pathname.indexOf('property/edit') !== -1 ||
  global.location.pathname.indexOf('foreign_property/edit') !== -1),
  onSubmitFail: function onSubmitFail(errors) {return errors && scrollToFirstError(errors);} }))(

PublishForm);


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/PublishForm.js
// module id = 1247
// module chunks = 0